import * as service from "../service";
import { store } from "../../store";

/**
 * Count the societies / organizers the current student follows.
 * Backend: GET /api/user/following/countFollowing
 */
export const CountFollowingAPI = async () => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/user/following/countFollowing", {
      user_id: user?.id,
    });
    return resp;
  } catch (err) {
    console.error(`CountFollowingAPI ${err}`);
    return { status: -1, resp: err };
  }
};

/**
 * Fetch a page of societies / organizers the current student follows.
 * Backend: GET /api/user/following/getFollowing
 */
export const GetFollowingAPI = async (page: number = 1) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call("GET", "api/user/following/getFollowing", {
      user_id: user?.id,
      page,
    });
    return resp;
  } catch (err) {
    console.error(`GetFollowingAPI ${err}`);
    return { status: -1, resp: err };
  }
};
